"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "20", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "#CB415E" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.285 10.142l4-4L14.142 5l-4 4-4-4L5 6.143l4 4-4 3.999 1.143 1.143 4-4 4 4 1.142-1.143-4-4z", fill: "#fff" }))); };
exports.default = Component;
//# sourceMappingURL=Declined.js.map